import "./index.css";
import A from "./a";
import B from "./b";

const Model: "a" | "b" = "a";

const Element = Model === "a" ? A : B;

export function App() {
	return <Element />;
}

export default App;
